import css from './index.module.scss';
import { useLang } from '@/i18n';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';

const M: React.FC = () => {
    const { t } = useLang('stream_ultra_x');
    const { locale = '' } = useRouter();
    const boxRef = useRef<HTMLDivElement>(null);

    const videoMap: { [key: string]: string[] } = {
        eu: [
            'https://websiteoss.ecoflow.com/upload/video/1754302173117/13_eu.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1754401324065/ai_1_en_pc.jpg',
            'https://websiteoss.ecoflow.com/upload/video/1754302308684/13_en_m.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1754401323826/ai_1_en_m.jpg',
        ],
        uk: [
            'https://websiteoss.ecoflow.com/upload/video/1754302235736/13_uk.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1754401324065/ai_1_en_pc.jpg',
            'https://websiteoss.ecoflow.com/upload/video/1754302308440/13_uk_m.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1754401323826/ai_1_en_m.jpg',
        ],
        de: [
            'https://websiteoss.ecoflow.com/upload/video/1754302173015/13_de.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1754401325150/ai_1_de_pc.jpg',
            'https://websiteoss.ecoflow.com/upload/video/1754302308426/13_de_m.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1754401323704/ai_1_de_m.jpg',
        ],
        fr: [
            'https://websiteoss.ecoflow.com/upload/video/1754302173002/13_fr.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1754401325351/ai_1_fr_pc.jpg',
            'https://websiteoss.ecoflow.com/upload/video/1754302308574/13_fr_m.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1754401324328/ai_1_fr_m.jpg',
        ],
        it: [
            'https://websiteoss.ecoflow.com/upload/video/1754302173006/13_it.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1754401324731/ai_1_it_pc.jpg',
            'https://websiteoss.ecoflow.com/upload/video/1754302308646/13_it_m.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1754401324940/ai_1_it_m.jpg',
        ],
        es: [
            'https://websiteoss.ecoflow.com/upload/video/1754302173014/13_es.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1754401325611/ai_1_es_pc.jpg',
            'https://websiteoss.ecoflow.com/upload/video/1754302308774/13_es_m.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1754401324531/ai_1_es_m.jpg',
        ],
    };

    const [load, setLoad] = useState(false);
    const [isM, setIsM] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsM(window?.innerWidth <= 1024);
            const sceneM = AniContainer.create({
                triggerElement: '.stream-ultra-x-H',
                triggerHook: 1,
                onEnter: () => setLoad(true),
            });
            return () => {
                sceneM.destroy();
            };
        }
    }, []);

    useEffect(() => {
        if (!load || !boxRef?.current) return;
        const playingVideo = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    const video: HTMLVideoElement | null = document.querySelector('#stream-ultra-x-M video');
                    if (video && entry.isIntersecting) {
                        video.currentTime = 0;
                        video.play();
                    }
                });
            },
            {
                threshold: 0.5,
            },
        );
        playingVideo.observe(boxRef.current);
        return () => {
            playingVideo.disconnect();
        };
    }, [load]);

    return (
        <section
            className={`${css.section} stream-ultra-x-M GtmModuleData-section`}
            id="stream-ultra-x-M"
            ref={boxRef}
            data-section-id={'stream-ultra-x-M'}
            data-section-title={t('M_title')}
        >
            <div className="video">
                <video
                    src={isM ? videoMap[locale][2] || videoMap.eu[2] : videoMap[locale][0] || videoMap.eu[0]}
                    poster={isM ? videoMap[locale][4] || videoMap.eu[4] : videoMap[locale][1] || videoMap.eu[1]}
                    autoPlay={false}
                    muted
                    loop
                    preload="auto"
                    width="100%"
                    height="100%"
                    playsInline
                    crossOrigin="anonymous"
                    aria-label={t('M_title')}
                />
            </div>
            <div className="info">
                <p className="title">{t('M_title')}</p>
                <p className="desc">{t('M_desc')}</p>
            </div>

            <div className="position-block" id="stream-ultra-x-M-position"></div>
        </section>
    );
};

export default M;
